import * as React from 'react';
import { useState } from 'react';

import Box from '@mui/material/Box';
import { EditHardwareModel } from '../../services/service'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { APITextField } from '../APITextField';
import { MenuItem } from '@mui/material';
import { APISelectField } from '../APISelectField';
import { FormDialog } from '../../components/FormDialog';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const validationSchema = Yup.object({
  manufacturer: Yup
    .string('Enter the hardware company name')
    .required('Field is required'),
  model: Yup
    .string('Enter hardware model')
    .required('model is required'),
  cpu_arch: Yup.string()
    .oneOf(['x86-64', 'armhf', 'armv7'])
    .required('Necessário escolher a quantidade!'),
})


export default function EditHardwareModelModal(props) {
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const { hardwareModel, onHardwareModelEdited, open, setOpen } = props

  // Instancia um formik, passando os valores iniciais como sendo os valores do hardwareModel
  // E também qual a lógica que será utilizada quando o mesmo for submetido (onSubmit)
  // Que no caso, é a requisição PUT para editar os hardwares.
  // Quando a requisição for bem sucedida, chamamos a função onHardwareModelEdited,
  // que é fornecida pelo parente que criou este componente

  const formik = useFormik({
    initialValues: hardwareModel,
    validationSchema: validationSchema,
  })

  const onSubmit = () => {
    console.log("Submitting")
    setLoading(true)
    const putData = {
      'manufacturer': formik.values.manufacturer,
      'model': formik.values.model,
      'cpu_model': formik.values.cpu_model,
      'cpu_arch': formik.values.cpu_arch,
      'cpu_frequency_ghz': formik.values.cpu_frequency_ghz,
      'cpu_cores': formik.values.cpu_cores,
      'ram_size_gb': formik.values.ram_size_gb,
      'disk_size_gb': formik.values.disk_size_gb
    }
    setLoading(true)
    const id = hardwareModel['id']
    EditHardwareModel(id, putData)
      .then((response) => {
          setOpen(false);
          onHardwareModelEdited(response.data);
      
      }).catch((err) => {
        setErrors(err.response.data);
      })
      .finally((resp) => {
        setLoading(false)
      })
  }

  const handleClose = () => {
    setOpen(false);
  };


  return (
        <Box sx={style} style={{ borderStyle: 'hidden', minWidth: '35rem', borderRadius: '0.5rem' }}>
          <FormDialog
            title={"Editar Modelo de Hardware"}
            open={open}
            onDismiss={handleClose}
            onSubmit={onSubmit}
            formWidth={500}
            loading={loading}
          >
            <APITextField
              id="model"
              label="Modelo"
              disabled={loading}
              value={formik.values.model}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.model}
            />
            <APITextField
              id="manufacturer"
              label="Fabricante"
              disabled={loading}
              defaultValue={formik.values.manufacturer}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.manufacturer}
            />
            <APITextField
              id="cpu_model"
              label="Modelo de CPU"
              disabled={loading}
              value={formik.values.cpu_model}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.cpu_model}
            />
            <APISelectField
              name="cpu_arch"
              value={formik.values.cpu_arch}
              onChange={formik.handleChange}
              variant={"standard"}
              label={"Selecione a Arquitetura"}
              errors={errors?.cpu_arch}
            >
              <MenuItem value='x86-64'>x86-64</MenuItem>
              <MenuItem value="armhf">armhf</MenuItem>
              <MenuItem value="armv7">armv7</MenuItem>
            </APISelectField>
            <APITextField id="cpu_frequency_ghz"
              label="Frequência da CPU "
              disabled={loading}
              value={formik.values.cpu_frequency_ghz}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.cpu_frequency_ghz}
            />
            <APITextField id="cpu_cores"
              label="Numero de núcleos  da CPU "
              disabled={loading}
              value={formik.values.cpu_cores}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.cpu_cores}
            />
            <APITextField id="ram_size_gb"
              label="Quantidade de Ram"
              disabled={loading}
              value={formik.values.ram_size_gb}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.ram_size_gb}
            />
            <APITextField id="disk_size_gb"
              label="Tamanho de armazenamento "
              disabled={loading}
              value={formik.values.disk_size_gb}
              onChange={formik.handleChange}
              variant="standard"
              errors={errors?.disk_size_gb}
            />
          </FormDialog>
        </Box>
  );
}